import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Card from "olive-react-myoneui/lib/Card";
import Form from "olive-react-myoneui/lib/Form";
import Posts from "./Posts";
import { getCache } from "../../../../components/Page/utils/cacheManager";
import { getNewsFeedLunchUrl, getNewsFeeds, getComments } from "../../../../api/afterLogin/newsFeed";
import { formatDaysAgo } from '../../../../helpers/datetime_helper';
import { format } from 'date-fns';
import { Global } from '../../../../api/afterLogin/newsFeed';
import { Loader, NewsfeedBlockLoader } from '../../Loader';

const CommunityForumTabs = ({ className = "", onPostsDataAvailable, newsfeedSPLunchUrl }) => {
  const configData = useSelector((state) => state.config);
  const adminData  = useSelector((state) => state.admin);
  const paths      = useSelector((state) => state.user.paths);
  const user       = useSelector((state) => state.user.user);
  const learner    = user.logged_in_user.user;
  const userProfle = user.logged_in_user.image === false ? adminData.header.us_image_url : user.logged_in_user.image;
  const [userToken, setUserToken] = useState(configData.access_token);
  const [newsFeedLunchUrl, setNewsFeedLunchUrl] = useState('');
  const [allNewsFeeds, setAllNewsFeeds] = useState([]);
  const [newsData, setNewsData]= useState([]);
  const [newsFeedApiUrl, setNewsFeedApiUrl] = useState('');
  const [postedComment, setPostedComment] = useState([]);
  const [isPostComment, setIsPostComment] = useState(false);
  const [newsMeta, setNewsMeta] = useState([]);
  const [newsPage, setNewsPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [infinitPostAPI, setInfinitPostAPI] = useState(false);
  const lastDivRef  = useRef(null);
  const scrollToRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  const params = {
    newsFeedBaseUrl:  configData.newsFeedBaseUrl,
  }

  const newsFeedlunchUrl = async () => {
    try {
      if (newsfeedSPLunchUrl) {
        const getUrl         = new URL(params.newsFeedBaseUrl);
        const newsFeedApiUrl = getUrl.hostname;

        const newsFeedUrl    = newsfeedSPLunchUrl;

        if (newsFeedUrl) {
          const newsFeeds = await getNewsFeeds({newsFeedApiUrl:newsFeedApiUrl, newsFeedUrl:newsFeedUrl});
          setNewsFeedLunchUrl(newsFeedUrl);
          setNewsFeedApiUrl(newsFeedApiUrl);
          if (newsFeeds) {
            setNewsData(newsFeeds);
            setAllNewsFeeds(newsFeeds.data);
            setNewsMeta(newsFeeds.meta);
            setIsLoading(false);
          }
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  }

  const addNewsFeedList = async () => {
    const currentPostCount = allNewsFeeds.length;
    const nextPage = newsPage + 1;
    setNewsPage(nextPage);
    setLoading(true);
    const params = {
      page: nextPage,
      newsFeedApiUrl:newsFeedApiUrl, 
      newsFeedUrl:newsFeedLunchUrl
    }
    try {
      const response = await getNewsFeeds(params);
      if (response) {
        const data = response.data;
        const newsList = [...allNewsFeeds, ...data];
        setAllNewsFeeds(newsList);
        setNewsMeta(response.meta);
        setInfinitPostAPI(false);

        const firstNewPost = document.getElementById(
          `post-${currentPostCount}`,
        );
        if (firstNewPost) {
          firstNewPost.scrollIntoView({ behavior: 'smooth' });
        }
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  };

  const listenLikeAction = () => {
    const socket = Global.getSocket();
    socket.on('like', (msg) => {
      let posts = [...allNewsFeeds]
      let obj = posts.find((item) => item._id === msg.data.newsFeedClient);
      let index = posts.indexOf(obj);

      if (posts.length > 0 && msg.message === 'success') {
        posts[index].totalLikes  = msg.data.totalLike;
        posts[index].likedByUser = msg.data.likedUsers.includes(adminData.user_id) ? 1 : 0;
        setAllNewsFeeds(posts);
      }
    });
  }

  const listenCommentAction = () => {
    const socket = Global.getSocket();
    socket.on('comment', async (response) => {
      if (response && response.data) {
        let msg   = response.data;
        let posts = [...allNewsFeeds];
        let obj   = posts.find((item) => item._id === msg.newsFeedClient);
        let index = posts.indexOf(obj);

        if (posts[index].comments === undefined || posts[index].comments === null) {
          posts[index].comments = [];
        }
        posts[index].totalComments = msg.totalComment;

        const params = {
            id: posts[index]._id,
            newsFeedApiUrl: newsFeedApiUrl,
            newsFeedLunchUrl: newsFeedLunchUrl
        }
        
        posts[index].comments = await getComments(params)

        setIsPostComment(true);
        setAllNewsFeeds(posts);
        setNewsData(response.data);
      }
    });
  }
  
  useEffect(() => {
    newsFeedlunchUrl();
  },[newsfeedSPLunchUrl]);

  useEffect(() => {
    const socket = Global.getSocket();
    if (socket) {
      listenLikeAction()
      listenCommentAction();
    }

    // Set up Intersection Observer
    const observer = new IntersectionObserver (
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !infinitPostAPI) {
            setInfinitPostAPI(true);
            if (newsMeta && newsMeta.pages > newsPage) {
              addNewsFeedList();
            }
          }
        });
      },
      { threshold: 0.5 },
    );

    if (lastDivRef.current) {
      observer.observe(lastDivRef.current);
    }

    return () => {
      socket.off("like");
      socket.off("comment");
      if (lastDivRef.current) observer.unobserve(lastDivRef.current);
    }
  },[newsData,newsMeta]);

  useEffect(() => {
    if (typeof onPostsDataAvailable === 'function') {
      onPostsDataAvailable(allNewsFeeds?.length > 0);
    }
    
  }, [allNewsFeeds]);

  const postsData = allNewsFeeds && allNewsFeeds.map((feed) => {
    let date   = feed?.newsFeed?.updatedAt ? feed?.newsFeed?.updatedAt : feed?.newsFeed?.createdAt; 
    return {
      userProfle: userProfle,
      newsFeedLunchUrl: newsFeedLunchUrl,
      newsFeedApiUrl: newsFeedApiUrl,
      postId: feed?._id,
      postLogo: feed?.newsFeed?.creator?.profilePic ?? "two",
      postTitle: feed?.newsFeed?.title ? feed?.newsFeed?.title[0].toUpperCase() + feed?.newsFeed?.title.slice(1) : '',
      postedTime: date !== undefined ? formatDaysAgo(date) : '',
      postMetaDesc: `${format(new Date(date),'MMMM')} ${feed?.newsFeed?.creator?.org}` ?? '',
      postDesc: feed?.newsFeed?.description ?? '',
      postDescCount: feed?.newsFeed?.description.length ?? 0,
      postLikedByUser: feed?.likedByUser,
      postComments: feed?.comments,
      postTotalComments: feed?.totalComments ?? 0,
      postTotalLikes: feed?.totalLikes ?? 0,
      postImage: feed?.newsFeed?.medias ?? null,
      postedComment:postedComment,
      className: "mb-3 p-3",
    }
  })
  return (
  <>
  {isLoading === true ? (
    <Card className={`${className} border-0 bg-transparent`}>
      <Card.Body className="p-0 tabs-community">
        <NewsfeedBlockLoader items={3}/>
      </Card.Body>
    </Card>
  ) : 
  (isLoading === false && postsData && postsData.length > 0) ? (
  <Card className={`${className} border-0 bg-transparent`}>
    <Card.Body className="p-0 tabs-community">
      <Form>
        {postsData?.map((post, index) => (
          <Posts key={index} {...post} postRef={lastDivRef} />
        ))}
      </Form>
    </Card.Body>
  </Card>
  ) : (
  <Card className={`newsfeed-empty empty-block-card`}>
    <Card.Body className="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
      <div className="empty-block">
        <h6><strong>News feeds!</strong></h6>
        <p>News feeds will appear here, once enabled .</p>
      </div>
    </Card.Body>
  </Card>
  )}
  </>
)};

export default CommunityForumTabs;
